import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "media-list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "my-4" }
const _hoisted_4 = { class: "media" }
const _hoisted_5 = { class: "media-left" }
const _hoisted_6 = { class: "image is-128x128" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "media-content" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "subtitle mb-1" }
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = { class: "level is-mobile" }
const _hoisted_13 = { class: "level-left is-vcentered" }
const _hoisted_14 = { class: "mx-1" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "my-4" }
const _hoisted_19 = { class: "media" }
const _hoisted_20 = { class: "media-left" }
const _hoisted_21 = { class: "image is-128x128" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "media-content" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "subtitle mb-1" }
const _hoisted_26 = { class: "mt-1" }
const _hoisted_27 = { class: "level is-mobile" }
const _hoisted_28 = { class: "level-left is-vcentered" }
const _hoisted_29 = { class: "mx-1" }
const _hoisted_30 = ["href"]
const _hoisted_31 = ["src"]

import { Collection } from "../types/Collection";
import mediaList from "../assets/links/media-links.json";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaList',
  props: {
    isAlbum: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const isAlbum = ref<boolean>(props.isAlbum);

const albums: Collection[] = mediaList.albums;
const tracks: Collection[] = mediaList.tracks;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isAlbum.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(albums), (album) => {
            return (_openBlock(), _createElementBlock("div", {
              key: album.title
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("article", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("figure", _hoisted_6, [
                      _createElementVNode("img", {
                        src: 
                    require(`../assets/img/album-covers/${album.albumCover}`)
                  
                      }, null, 8, _hoisted_7)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, [
                        _createElementVNode("strong", null, _toDisplayString(album.title), 1)
                      ]),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(album.releaseDate), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(album.links, (link) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "level-item",
                              key: link.label
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("a", {
                                  class: "icon",
                                  href: link.url
                                }, [
                                  _createElementVNode("img", {
                                    src: require(`../assets/img/icons/${link.icon}`)
                                  }, null, 8, _hoisted_16)
                                ], 8, _hoisted_15)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tracks), (track) => {
            return (_openBlock(), _createElementBlock("div", {
              key: track.title
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("article", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("figure", _hoisted_21, [
                      _createElementVNode("img", {
                        src: 
                    require(`../assets/img/album-covers/${track.albumCover}`)
                  
                      }, null, 8, _hoisted_22)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, [
                        _createElementVNode("strong", null, _toDisplayString(track.title), 1)
                      ]),
                      _createElementVNode("p", _hoisted_26, _toDisplayString(track.releaseDate), 1),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(track.links, (link) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "level-item",
                              key: link.label
                            }, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("a", {
                                  class: "icon",
                                  href: link.url
                                }, [
                                  _createElementVNode("img", {
                                    src: require(`../assets/img/icons/${link.icon}`)
                                  }, null, 8, _hoisted_31)
                                ], 8, _hoisted_30)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
  ]))
}
}

})